export class DrawingPreviewClickPosition {
  constructor(public x: number, public y: number) {}
}
